import React from 'react';
import { compose, mapProps } from 'recompose';
import { withRouter } from 'react-router-dom';

import { Divider, List, ListItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AssessmentProgressBar from 'components/threepp/AssessmentProgressBar/AssessmentProgressBar';
import { dateSortMethod, getDueDate, getSubmittedDate, navToAssessment, StyledBadge } from '../AssessmentsTable/AssessmentsTable';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'block',
    '&:hover': {
      backgroundColor: 'rgba(23, 109, 194, 0.07)'
    },
    '&:nth-of-type(odd)': {
      backgroundColor: '#F7F7F7'
    }
  },
  name: {
    marginBottom: '0.5rem',
    textAlign: 'justify',
    whiteSpace: 'pre-wrap'
  },
  progressBar: {
    borderBottom: 'none'
  },
  progressDetail: {
    float: 'right',
    marginBottom: '0rem'
  }
}));

const MobileAssessmentsTable = props => {
  const classes = useStyles();
  const { assessments } = props;
  return (
    <List component="nav" aria-label="mailbox folders">
      {assessments &&
        assessments.length !== 0 &&
        dateSortMethod(assessments).map(row => {
          return (
            <React.Fragment key={`${row.id}x`}>
              <ListItem button className={classes.root} onClick={() => navToAssessment(row.id, props)} key={row.id}>
                <StyledBadge
                  className={classes.badge}
                  style={{ display: 'inline', top: '10px' }}
                  key={row.id}
                  color="primary"
                  variant="dot"
                  invisible={row.status !== 'NEW'}
                />
                <p style={row.status === 'NEW' ? { fontWeight: 600 } : {}} className={classes.name}>
                  {row.name}
                </p>
                <p className={classes.name}>{row.company}</p>
                {row.status === 'SUBMITTED' || row.status === 'SUBMITTED_SYNC_SUCCESS'
                  ? getSubmittedDate(row.submitDate, true)
                  : getDueDate(row, true)}
                <p className={classes.progressDetail}>{`${row.metadata.answeredFields}/${row.metadata.totalFields}`}</p>
                <AssessmentProgressBar
                  className={classes.progressBar}
                  answered={row.metadata.answeredFields}
                  total={row.metadata.totalFields}
                  isMobile
                />
              </ListItem>
              <Divider key={`${row.id}i`} />
            </React.Fragment>
          );
        })}
    </List>
  );
};

export const MobileAssessmentsTableHOC = compose(
  withRouter,
  mapProps(props => ({
    history: props.history,
    assessments: props.assessments
  }))
);

export default MobileAssessmentsTableHOC(MobileAssessmentsTable);
